export default __webpack_public_path__ + "1959325ecd93b9918f9e63fb70f6fe57.png";